import { Component, OnInit } from '@angular/core';
import { Router, ActivatedRoute } from '@angular/router';
import { OkAloneService } from 'src/app/ok-alone.service';
import { AbstractControl, FormBuilder, FormControl, FormGroup, ValidationErrors, Validators } from '@angular/forms';

declare var _: any;


@Component({
  selector: 'app-monitors-adp',
  templateUrl: './monitors-adp.component.html',
  styleUrls: ['./monitors-adp.component.scss']
})
export class MonitorsAdpComponent implements OnInit {

  users : any;
  original_users: any;
  search = "";
  page = 1;
  loading = true;

  show_consent = false;

  constructor(private router: Router, private route: ActivatedRoute, public okService:OkAloneService) { }



  ngOnInit(): void {

    this.checkAccess();

  }


  checkAccess(){
    this.loading = true;

    this.okService.get("adp/api-access",{page:this.page})
    .subscribe((data:any) => {

      let access = data.body['access'];

      if(access){
        this.getUsers();
      }else{
        this.loading = false;
        this.show_consent = true;
      }


    });

  }
  
  getUsers(){
    this.loading = true;

    this.okService.get("adp/workers",{page:this.page})
    .subscribe((data) => {

      this.users = data.body;

      this.loading = false;

      //console.log(this.users.length);


    });

  }
  
  importMonitor(user:any){
    //console.log(user);        
    
    this.okService.post("monitors",user)
    .subscribe((data) => {

      //console.log(data);

      user.is_monitor = true;

      this.okService.setAlert("The monitor "+user.name+" has been added","success");

    });
  }

  doSearch(){
    //console.log(this.search);

    let search = this.search;

    this.okService.get("adp/workers",{search:search})
    .subscribe((data) => {

      this.users = data.body;

      //console.log(this.users.length);


    });


  }
  cancelSearch(){
    //console.log(this.search);

    this.search="";

    this.getUsers();

  }

  prevPage(){

    if(this.page > 1){
      this.page = this.page - 1;
      this.getUsers();

    }
  }

  nextPage(){

    this.page = this.page + 1;
    this.getUsers();

  }
}
